import React from 'react';
import { Property, AppUser, UserRole } from '../../../types';
import { formatSafePropertyText } from '../../../utils/propertyValueFormatter';
import { PropertyTagsList } from '../card/PropertyTagsList';

const DetailItem: React.FC<{ label: string; value: any }> = ({ label, value }) => {
    const formatted = formatSafePropertyText(value, '--');
    return (
        <div className="flex flex-col p-2">
            <span className="text-[9px] text-gray-400 font-black uppercase tracking-widest mb-1">{label}</span>
            <span className="text-xs font-black text-gray-800 uppercase leading-tight break-words">{formatted}</span>
        </div>
    );
};

export const PropertyTechnicalGrid: React.FC<{ property: Property; appUser?: AppUser | null }> = ({ property, appUser }) => {
    const antiguedadVal = typeof property.constructionYear === 'number' && !isNaN(property.constructionYear) && property.constructionYear > 1800
        ? `${new Date().getFullYear() - property.constructionYear} Años`
        : property.antiguedad;

    const canSeeRegistryData = appUser && [
        UserRole.COMERCIAL_INTERNO,
        UserRole.BROKER_INTERNO,
        UserRole.ADMIN,
        UserRole.SUPERADMIN,
        UserRole.OPERACION
    ].includes(appUser.role);

    return (
        <div className="bg-gray-50/50 rounded-3xl p-6 grid grid-cols-2 sm:grid-cols-3 gap-y-8 gap-x-4 border border-gray-100 shadow-sm animate-fade-in">
            <DetailItem label="Barrio" value={property.neighborhoodName} />
            <DetailItem label="Localidad" value={property.localidad} />
            <DetailItem label="Estrato" value={property.estrato} />
            
            <DetailItem label="Antigüedad" value={antiguedadVal} />
            <DetailItem label="Piso" value={property.piso} />
            {property.ascensor !== undefined && property.ascensor !== null && (
                <DetailItem
                    label="Ascensores"
                    value={
                        Number(property.ascensor) > 1
                            ? `${property.ascensor}`
                            : Number(property.ascensor) === 1
                            ? 'Sí (1)'
                            : 'No (0)'
                    }
                />
            )}
            
            <DetailItem label="Código BRP" value={property.codigo_brp} />

            {canSeeRegistryData && (
                <>
                    <DetailItem label="Número de la Matrícula" value={property.numero_matricula} />
                    <DetailItem label="Número del Predial" value={property.numero_predial} />
                </>
            )}

            {/* Campos condicionales solicitados */}
            {property.disponibilidad_visitas != null && (
                <DetailItem label="Horario Visita" value={property.disponibilidad_visitas} />
            )}
            {property.observaciones_internas != null && (
                <DetailItem label="Observaciones" value={property.observaciones_internas} />
            )}

            {/* Tags del Inmueble */}
            {((property.tag && property.tag.length > 0) || (property.tags && property.tags.length > 0)) && (
                <div id={`detail-tags-section-${property.id || property.codigo}`} className="col-span-2 sm:col-span-3 p-2 pt-4 border-t border-gray-100">
                    <span className="text-[9px] text-gray-400 font-black uppercase tracking-widest mb-2 block">Tags del Inmueble</span>
                    <PropertyTagsList
                        tags={property.tag || property.tags}
                        maxVisible={10}
                        size="sm"
                        showIcon={true}
                        idPrefix={`detail-tags-${property.id || property.codigo}`}
                    />
                </div>
            )}
        </div>
    );
};